/** Add the newest matching Telegram RawItems without discarding existing selections. */
export const selectTelegramBulk = (
  existing: readonly string[],
  rows: readonly { raw_item_id: string; operator_hidden_at?: unknown }[],
  limit = 30
): { ids: string[]; added: number; truncated: boolean } => {
  const selected = [...new Set(existing)];
  const eligible = [...new Set(rows
    .filter(row => !row.operator_hidden_at)
    .map(row => row.raw_item_id)
    .filter(Boolean))];
  const missing = eligible.filter(id => !selected.includes(id));
  const available = Math.max(0, limit - selected.length);
  const added = missing.slice(0, available);
  return {
    ids: [...selected, ...added],
    added: added.length,
    truncated: missing.length > available
  };
};
